interface Resource {
  type: 'image'
  url: string
}

interface Options {
  progress?: (current: number, total: number) => void
}

async function loadImage(url: string): Promise<void> {
  const img = new Image()
  img.src = url
  return await new Promise((resolve) => {
    img.onload = () => {
      resolve()
    }
  })
}

export default async function resourceLoader(
  resources: Resource[],
  options: Options = {}
): Promise<void> {
  const total = resources.length
  let finish = 0
  return await Promise.all(
    resources.map(
      async (res) =>
        await loadImage(res.url).then(() => {
          finish += 1
          if (options.progress) {
            options.progress(finish, total)
          }
        })
    )
  ).then()
}
